import React from "react";
import SideMenu from "./SideMenu";
import { buildSideMenuItems } from "./menuItems";

export const sideMenuItems = buildSideMenuItems("/branch", {
  includeReceivablesPayables: true,
});

const ManagerSideMenu = () => {
  return <SideMenu sideMenuItems={sideMenuItems} />;
};

export default ManagerSideMenu;
